<template>
    <div>
        <b-img
            :src="getLogoForMake"
            class="make-logo"
            :class="iconClass"
            :alt="make.name"
        />
        <span class="make-name">
            {{ make.name }}
        </span>
    </div>
</template>

<script>
import { BImg } from "bootstrap-vue";

export default {
    components: {
        BImg
    },
    props: {
        make: {
            type: Object,
            required: true
        },
        path: {
            type: String,
            required: true
        },
        iconClass: {
            type: String
        }
    },
    computed: {
        getLogoForMake() {
            // logo image path is
            const allSpacesAndDashes = /\s|-/g;
            const logoImageName = this.make.name
                .replace(allSpacesAndDashes, "_")
                .toLowerCase();
            return this.path + "/" + logoImageName + ".png";
        }
    }
};
</script>

<style lang="scss" scoped>
$check-mark-active: #54b848;
$primary-blue: #007dc6;

.make-name {
    user-select: none;
}

.make-logo {
    height: 25px;
    width: 25px;
}
</style>
